import React, { useState } from "react";
import LandingHeader from "../common/LandingHeader";
import LandingFooter from "../common/LandingFooter";
import './landing.css';



const serviceCards = [
  {
    btnClass: "btn-vertical--01",
    number: "01",
    dynamicText: "Personalized AI Tutoring for Every Learner",
    img: "./assets/images/landing/service--01.svg",
    title: "Every student learns differently - we make sure they’re guided accordingly.",
    desc: "JIGYAASU acts as a 24/7 personal tutor led by AI - delivering tailored learning experiences to every student. It dynamically adapts to their pace, identifies learning gaps, and offers targeted practice to strengthen weak areas. Whether a student needs revision or advanced problem-solving, Jigyaasu ensures each learner gets the support they need when they need it. This empowers institutions to offer scalable, high-quality academic assistance beyond classroom hours."
  },
  {
    btnClass: "btn-vertical--02",
    number: "02",
    dynamicText: "Flexible Code Practice – Built Around Student Needs",
    img: "./assets/images/landing/service--02.svg",
    title: "Let students code how they want, not how the platform dictates.",
    desc: "With Jigyaasu’s Code Practice Module, students can choose their preferred programming language, challenge type(Missing Code, Bug Hunt, or New Code), and difficulty level.They can also upload their own study materials - like PDFs or Doc’s - to practice coding alongside personal notes or assignments.This flexibility ensures a highly personalized, engaging coding experience that builds confidence and improves logical thinking in real - world scenarios."
  },
  {
    btnClass: "btn-vertical--03",
    number: "03",
    dynamicText: "Daily Smart Assessments for Continuous Progress",
    img: "./assets/images/landing/service--03.svg",
    title: "Because daily learning deserves daily feedback.",
    desc: "Jigyaasu makes assessment a daily habit, offering live tests that are automatically tailored to each student’s current learning level.These assessments not only reinforce classroom concepts but also help students build exam discipline and track their progress over time.Institutions benefit from structured, ongoing evaluation without additional admin effort - ensuring learning stays measurable and meaningful."
  },
  {
    btnClass: "btn-vertical--04",
    number: "04",
    dynamicText: "Actionable Insights That Go Beyond Scores",
    img: "./assets/images/landing/service--04.svg",
    title: "It’s not just about marks - it’s about meaningful learning.",
    desc: "Our platform doesn’t just deliver marks - it uncovers meaningful patterns in student performance.With AI- generated insights, educators and institutions can understand topic - level mastery, identify struggling learners early, and make data - informed academic decisions.These insights drive targeted interventions, ensure no student is left behind, and support better overall classroom outcomes."
  },
  {
    btnClass: "btn-vertical--05",
    number: "05",
    dynamicText: "Institution Ready. Seamless to Deploy.",
    img: "./assets/images/landing/service--05.svg",
    title: "No complex setups. Just plug in and start scaling learning",
    desc: "Jigyaasu is built with institutions in mind - it’s cloud-based, secure, and easy to integrate with minimal change management.Whether you're a single school or a large education group, the platform scales effortlessly and comes with administrative dashboards, classroom tracking, and student engagement tools. It enhances what teachers already do, without disrupting the current curriculum or workflows."
  }
];

const LandingPage = () => {
  const [activeCard, setActiveCard] = useState(0);

  return (
    <div className="landing overflow-hidden">
      <section className="section heroSec pt-4">

        <LandingHeader />

        <div className="container">
          <div className="hero-main">
            <div className="hero-main__content">
              <h1 className="ff3 main-hero-heading">
                Your Personal Ultimate Tutor JIGYAASU
              </h1>
              <p className="fz20 sub-title">
                It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.
              </p>

              <button className="btn btn-solid btn-solid--dark fw500">
                Get Started
              </button>
            </div>
            <div className="hero-main__img">
              <img src="./assets/images/landing/home-hero-image.png" alt="hero-image" />
            </div>
          </div>
        </div>

        {/* <div className="container">
          <div className="mt-5 ff1 fs30">Font 1</div>
          <div className="mt-5 ff2 fs30">Font 2</div>
          <div className="mt-5 ff3 fs30">Font 3</div>
        </div> */}
      </section>

      <section className="ff2 section hiSec">
        <div className="container">
          <h6 className="fz20 fw700 hi-there">[Hi <span></span> There]</h6>
          <h2 className="fz64 fw700 hi-title">
            At JIGYAASU, we think that AI can change how students learn and succeed academically.
          </h2>

          <div className="divided-content">
            <div className="divided-content__text">
              <p className="ff1 fz24">
                Our AI tools help students understand better, improve their learning, and reach their goals. Come along on this exciting adventure with us and see all the amazing things AI can do in education.
              </p>

              <button className="btn btn-solid btn-solid--dark fw500">
                Learn About Us
              </button>
            </div>
            <div className="divided-content__img">
              <img src="./assets/images/landing/home-hi-image.svg" alt="" />
            </div>
          </div>
        </div>
      </section>

      <section className="section ff2 serviceSec">
        <div className="container">
          <h2 className="fz72 ff3 text-center fw700 section-heading1">Our Services</h2>

          <p className="fz20 sub-title">
            Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, <br /> or randomised words which don't look even slightly believable.
          </p>
        </div>

        <div className="clickable-cards">
          {serviceCards.map((card, idx) => (
            <div
              key={idx}
              className={`service-card service-card--0${idx + 1}${activeCard === idx
                ? " active"
                : activeCard > idx
                  ? " all-clicked"
                  : ""
                }`}
            >
              <button
                className={`btn fz22 fw700 btn-vertical ${card.btnClass}`}
                onClick={() => setActiveCard(idx)}
              >
                <span className="number">{card.number}</span>
                <span className="dynamic-text">{card.dynamicText}</span>
              </button>
              <div className="service-card__img">
                <img src={card.img} alt="" />
              </div>
              <div className="text-white service-card__text">
                <h3 className="ff2 fw700 fz36">{card.title}</h3>
                <p className="ff1 fz18 mb-0">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="section partnersSec">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h3 className="section-heading2">JIGYAASU is an innovative AI platform designed to support students in their academic journey.</h3>
              <p className="fz24 opacity-text70">With a range of powerful AI creation tools, students can harness the power of artificial intelligence to enhance their learning experience. Whether it's seeking assistance from an AI chatbot, analyzing documents, getting subject-based home help, creating flowcharts, or practicing coding, Mygrades Ai has got it covered.</p>
            </div>
            <div className="col-md-6 align-self-center text-center">
              <div className="partnersSec__topCard">
                <img className="partnersSec__topCard-img" src="./assets/images/landing/partners/topimg.png" alt="" />
              </div>
              <img src="" alt="" />
            </div>
          </div>

          <div className="partnersSec__head-top">
            <h2 className="ff3 fz72 fw700 section-heading1">Our Partners</h2>
            <p className="">Many desktop publishing packages and web page editors now use Lorem Ipsum.</p>
          </div>
          <div className="partnersSec__partners">
            <div className="row">
              <div className="col-6 col-md-3">
                <div className="partnersSec__simgle">
                  <img src="./assets/images/landing/partners/img1.svg" alt="partner" />
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="partnersSec__simgle">
                  <img src="./assets/images/landing/partners/img2.svg" alt="partner" />
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="partnersSec__simgle">
                  <img src="./assets/images/landing/partners/img3.svg" alt="partner" />
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="partnersSec__simgle">
                  <img src="./assets/images/landing/partners/img4.svg" alt="partner" />
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="partnersSec__simgle">
                  <img src="./assets/images/landing/partners/img5.svg" alt="partner" />
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="partnersSec__simgle">
                  <img src="./assets/images/landing/partners/img6.svg" alt="partner" />
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="partnersSec__simgle">
                  <img src="./assets/images/landing/partners/img7.svg" alt="partner" />
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="partnersSec__simgle">
                  <img src="./assets/images/landing/partners/img8.svg" alt="partner" />
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="partnersSec__simgle">
                  <img src="./assets/images/landing/partners/img9.svg" alt="partner" />
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="partnersSec__simgle">
                  <img src="./assets/images/landing/partners/img10.svg" alt="partner" />
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="partnersSec__simgle">
                  <img src="./assets/images/landing/partners/img11.svg" alt="partner" />
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="partnersSec__simgle">
                  <img src="./assets/images/landing/partners/img12.svg" alt="partner" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="section knowledgeSec">
        <div className="container">
          <div className="knowledgeFirst">
            <div className="bdrs40 knowledgeFirst__card">
              <h2 className="ff2 fz64 fw700 mb-3 text-white">
                The Ultimate Knowledge Powerhouse
              </h2>
              <p className="fz24 ff1 opacity-text70">
                AIRA has absorbed a vast ocean of information, enabling captivating conversations on intricate topics with unrivaled expertise.
              </p>
              <div className=" bottom-row">
                <button className="btn btn-solid btn-solid--white">
                  <span> Learn Aira Chat </span>
                </button>
              </div>
            </div>

            <div className="knowledgeFirst__img">
              <img src="./assets/images/landing/knowledgeChat.png" alt="chat" />

              <div className="pulse-anim-block">
                <div className="position-relative item">
                  <div className="pulse-anim">
                    <img src="./assets/images/landing/icon-send.svg" alt="" />
                  </div>
                  <div className="circle" style={{ animationDelay: "0s" }}></div>
                  <div className="circle" style={{ animationDelay: "1s" }}></div>
                  <div className="circle" style={{ animationDelay: "2s" }}></div>
                  <div className="circle" style={{ animationDelay: "3s" }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="section codeSec">
        <div className="container">
          <div className="text-center">
            <div className="codeSec__top d-inline-block">
              <h2 className="ff3 fz72 fw700 section-heading1">Code Practice</h2>
              <p className="fz24 ">AIRA has absorbed a vast ocean of information, enabling captivating conversations on intricate topics with unrivaled expertise.</p>
            </div>
          </div>

          <div className="codeSec__codeArea">
            <img className="codeSec__codeIde" src="./assets/images/landing/code-ide2.png" alt="code ide" />
            <img className="codeSec__codeDeco1 anim-up-down" src="./assets/images/landing/code-deco1.svg" alt="Student" />
            <img className="codeSec__codeDeco2 anim-up-down" src="./assets/images/landing/code-deco2.svg" alt="Tutor" />

            <pre className="codeSec__code">
            </pre>
          </div>
        </div>
      </section>

      <section className="section statsSec">
        <div className="container">
          <div className="d-flex align-items-center gap-5">
            <div className="flex-shrink-0">
              <h2 className="ff3 fz72 fw700">Our Statistics</h2>
              <p className="ff1 statsSec__desc">Lorem Ipsum is simply dummy text of the <br /> printing and typesetting industry.</p>
            </div>
            <div className="flex-grow-1 ms-3">
              <div className="row">
                <div className="col-md-4 text-center br-1">
                  <div className="statsSec__num">2M+</div>
                  <div className="statsSec__text">User</div>
                </div>
                <div className="col-md-4 text-center br-1">
                  <div className="statsSec__num">1.2M</div>
                  <div className="statsSec__text">Roles</div>
                </div>
                <div className="col-md-4 text-center">
                  <div className="statsSec__num"><span className="animate-number" data-number="1000">1000</span>+</div>
                  <div className="statsSec__text">Offer & deals</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section className="section knowledgeSec2">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h2 className="ff2 fw700 section-heading2">The Ultimate Knowledge Powerhouse</h2>

              <div className="ff2 accordion" id="accordion1">
                <div className="rounded-0 accordion-item">
                  <h2 className="accordion-header">
                    <button className="fz24 rounded-0 accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#accordion1Collapse1" aria-expanded="true" aria-controls="accordion1Collapse1">
                      AIRA has absorbed a vast ocean
                    </button>
                  </h2>
                  <div id="accordion1Collapse1" className="accordion-collapse collapse show" data-bs-parent="#accordion1">
                    <div className="pt-0 accordion-body">
                      AIRA has absorbed a vast ocean of information, enabling captivating conversations on intricate topics with unrivaled expertise.
                    </div>
                  </div>
                </div>
                <div className="rounded-0 accordion-item">
                  <h2 className="accordion-header">
                    <button className="fz24 rounded-0 accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion1Collapse2" aria-expanded="false" aria-controls="accordion1Collapse2">
                      AIRA has absorbed a vast ocean
                    </button>
                  </h2>
                  <div id="accordion1Collapse2" className="accordion-collapse collapse" data-bs-parent="#accordion1">
                    <div className="pt-0 accordion-body">
                      AIRA has absorbed a vast ocean of information, enabling captivating conversations on intricate topics with unrivaled expertise.
                    </div>
                  </div>
                </div>
                <div className="rounded-0 accordion-item">
                  <h2 className="accordion-header">
                    <button className="fz24 rounded-0 accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion1Collapse3" aria-expanded="false" aria-controls="accordion1Collapse3">
                      AIRA has absorbed a vast ocean
                    </button>
                  </h2>
                  <div id="accordion1Collapse3" className="accordion-collapse collapse" data-bs-parent="#accordion1">
                    <div className="pt-0 accordion-body">
                      AIRA has absorbed a vast ocean of information, enabling captivating conversations on intricate topics with unrivaled expertise.
                    </div>
                  </div>
                </div>
                <div className="rounded-0 accordion-item">
                  <h2 className="accordion-header">
                    <button className="fz24 rounded-0 accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion1Collapse4" aria-expanded="false" aria-controls="accordion1Collapse3">
                      AIRA has absorbed a vast ocean
                    </button>
                  </h2>
                  <div id="accordion1Collapse4" className="accordion-collapse collapse" data-bs-parent="#accordion1">
                    <div className="pt-0 accordion-body">
                      AIRA has absorbed a vast ocean of information, enabling captivating conversations on intricate topics with unrivaled expertise.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 align-self-center text-end">
              <div className="knowledgeSec2__right-wrapper move-up">
                <img className="anim-up-down" src="./assets/images/landing/img1.png" alt="" />
              </div>
            </div>
          </div>

        </div>
      </section>

      <LandingFooter />
    </div>
  );
};

export default LandingPage;
